import { useCallback, useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { logout } from '../store';

// const initialState = (entry) => {
//   const state = {};
//   for (const key in entry) {
//     state[key] = {
//       loading: true,
//       error: null,
//       data: null,
//     };
//   }
//   return state;
// };

// const httpReducer = (curHttpState, action) => {
//   let newState;
//   switch (action.type) {
//     case 'SEND':
//       newState = { ...curHttpState };
//       newState[action.key] = { loading: true, error: null, data: null };
//       return newState;
//     case 'RESPONSE':
//       newState = { ...curHttpState };
//       newState[action.key] = { ...newState[action.key], loading: false, data: action.responseData };
//       return;
//     case 'ERROR':
//       newState = { ...curHttpState };
//       newState[action.key] = { loading: false, error: action.errorMessage };
//       return newState;
//     case 'CLEAR':
//       return initialState(action.inital);
//     default:
//       throw new Error('Should not be reached!');
//   }
// };

const BaseURL = 'http://213.233.177.17:8022/';

const AsyncRequests = ({ reqData, Key }) => {
  // const [httpState, dispatchHttp] = useReducer(httpReducer, initialState(reqData));
  const [theEntry, setEntry] = useState(reqData);
  const [TheKey, setTheKey] = useState(Key);
  const [final, setFinal] = useState(() => {
    const the = {};
    for (const key in reqData) {
      the[key] = null;
    }
    return the;
  });
  const [isLoading, setIsLoading] = useState({ total: true });
  const [Done, setDone] = useState(false);
  const dispatch = useDispatch();

  const [shoot, setShoot] = useState(false);
  useEffect(() => {
    if (shoot) {
      dispatch(logout());
    }
  }, [dispatch, shoot]);

  // useEffect(() => console.log(entry), [entry]);
  // useEffect(() => setEntry(entry), [entry]);

  // const clear = useCallback((inital) => dispatchHttp({ type: 'CLEAR', inital: inital }), []);
  const clear = useCallback((inital) => {}, []);

  const sendRequest = useCallback(
    ({ url, method, body, header }, key) => {
      setIsLoading((pre) => {
        const neew = { ...pre };
        neew[key] = true;
        return neew;
      });
      // dispatchHttp({ type: 'SEND', key: key });
      fetch(BaseURL + url, {
        method: method,
        body: body,
        headers: {
          ...header,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((responseData) => {
          const detail = responseData.detail;
          if (
            responseData &&
            (detail === 'Invalid Token' ||
              detail === 'Access token expired' ||
              detail === 'Given token not valid for any token type')
          ) {
            setShoot(true);
          }

          setFinal((pre) => {
            const newState = { ...pre };
            newState[key] = responseData;
            return newState;
          });
          setIsLoading((pre) => {
            const neew = { ...pre };
            neew[key] = false;
            return neew;
          });
          // dispatchHttp({
          //   type: 'RESPONSE',
          //   responseData: responseData,
          //   key: key,
          // });
        })
        .catch((error) => {
          setFinal((pre) => {
            const newState = { ...pre };
            newState[key] = { error: `sth went wrg!-> ${error}` };
            return newState;
          });
          setIsLoading((pre) => {
            const neew = { ...pre };
            neew[key] = false;
            return neew;
          });
          // dispatchHttp({
          //   type: 'ERROR',
          //   errorMessage: `Something went wrong! -> ${error}`,
          //   key: key,
          // });
        });
    },
    [setFinal]
  );

  useEffect(() => {
    for (const key in theEntry) {
      sendRequest({ ...theEntry[key] }, key);
    }
  }, [sendRequest, theEntry]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isLoading.total === false) {
        return;
      }

      let loading = false;
      let done = true;
      for (const key in final) {
        if (isLoading[key]) {
          loading = true;
        }
        // loading = loading || httpState[key].loading;
        if (!final[key]) {
          done = false;
        }
      }

      if (loading === false) {
        setIsLoading((pre) => {
          const neew = { ...pre };
          neew.total = loading;
          return neew;
        });
      }
      if (done) {
        setDone(done);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [setIsLoading, final, isLoading]);

  useEffect(() => console.log(Done, isLoading), [Done, isLoading]);

  const NewRequest = useCallback(
    ({ NewReqData, NewKey }) => {
      clear(NewReqData);
      setIsLoading({ total: true });
      setDone(false);
      setEntry(NewReqData);
      setFinal(() => {
        const the = {};
        for (const keys in NewReqData) {
          the[keys] = null;
        }
        return the;
      });
      setTheKey(NewKey);
    },
    [clear, setIsLoading, setEntry, setTheKey, setFinal, setDone]
  );

  return {
    finalData: Done ? final : null,
    isLoadingAsync: isLoading.total,
    clearAsync: clear,
    NewRequest: NewRequest,
    Key: Done ? TheKey : 'loading',
  };
};

export default AsyncRequests;
